import { render, staticRenderFns } from "./Tab-I-II.vue?vue&type=template&id=0893bce4"
import script from "./Tab-I-II.vue?vue&type=script&lang=js"
export * from "./Tab-I-II.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports